import { Box, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import { ProfessionProforientationGenericEventCard } from 'portfolio3/features/pdf/components/cards';
import { IndustrySpecialityList } from 'portfolio3/features/proforientation';
import { ProforientationMappedDodData } from 'portfolio3/features/proforientation/model/selectors/events';
import { activeFormatSelector } from 'selectors/drawers';

import SpecialityContainer from './SpecialityContainer';

type EventOpenDaySectionProps = {
  data: ProforientationMappedDodData[];
};

const EventOpenDaySection = ({ data }: EventOpenDaySectionProps) => {
  const format = useAppSelector(activeFormatSelector);

  return (
    <Box className="event-open-day">
      <Typography variant="Headings/H5">Дни открытых дверей</Typography>
      <Box marginTop="16px" className="event-open-day__content">
        <Box display="grid" gridTemplateColumns={format === 'horizontal' ? '1fr 1fr' : '1fr'} gap="16px">
          {data.map((event, index) => {
            const key = `${event.date}-${event.name}-${index}`;

            return (
              <ProfessionProforientationGenericEventCard
                key={key}
                date={event.date}
                title={event.name}
                industry={event.industry}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default EventOpenDaySection;
